import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { GoChecklist } from "react-icons/go";
import { useHistory } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { Overlay } from "../../routes/styles";
import { fadeIn } from "../../util/animation";
import {
  CloseIcon,
  Container,
  JoinButton,
  RulesContainer,
  RulesContent,
  RulesDescription,
  RulesHeader,
  Title,
} from "./styles";

export default function Home() {
  const history = useHistory();
  const [showRules, setShowRules] = useState(false);
  const { goToTop } = useApp();

  useEffect(() => {
    goToTop();
  }, [goToTop]);

  return (
    <Container
      as={motion.div}
      variants={fadeIn}
      initial="hidden"
      animate="show"
      className="bg-overlay"
    >
      <div className="container ">
        <div className="row rowsafari container">
          <div className="col-lg-12">
            <div className="text-right header-width">
              <h1 className="section-margin-bottom text-white">
                2025 Masters Pool with the Big Guy
              </h1>
              <p className="intro-content text-white">
                Welcome to the <i>Masters Pool with the Big Guy</i>.
              </p>
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/leaderboard")}>
                  <GoChecklist size={24} />
                  Leaderboard
                </JoinButton>
              </div>
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/scoreboards")}>
                  <GoChecklist size={24} />
                  Scorecards
                </JoinButton>
              </div>
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/selections")}>
                  <GoChecklist size={24} />
                  Selections
                </JoinButton>
              </div>
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/geography")}>
                  <GoChecklist size={24} />
                  Geography
                </JoinButton>
              </div>
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/whatif")}>
                  <GoChecklist size={24} />
                  What if?
                </JoinButton>
              </div>
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/predictions")}>
                  <GoChecklist size={24} />
                  Predictions
                </JoinButton>
              </div>
              {/* <div className="row mt-2">
                <JoinButton onClick={() => history.push('/emotions')}>
                  <GoChecklist size={24}/>
                  Fan Engagement
                </JoinButton>
              </div> */}
              <div className="row mt-2">
                <JoinButton onClick={() => history.push("/about")}>
                  <GoChecklist size={24} />
                  About IPC
                </JoinButton>
              </div>
              <div className="row mt-2">
                <JoinButton onClick={() => setShowRules(true)}>
                  <GoChecklist size={24} />
                  Rules
                </JoinButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Overlay isOpen={showRules} />
      <RulesContainer isOpen={showRules}>
        <RulesContent>
          <RulesHeader className="sticky-top">
            <Title>Rules</Title>
            <CloseIcon onClick={() => setShowRules(false)}>
              <AiOutlineClose size={24} />
            </CloseIcon>
          </RulesHeader>
          <RulesDescription className="">
            <ol className="circle-list">
              <li>
                <h2>{}</h2>
                <p>
                  Choose one A player, two Bs, two Cs, and one D. That should
                  give you 6 total players. Your picks will be recorded and
                  should be confirmed back to you via email. Check your Junk and
                  Spam folders if you don't see it come through.
                </p>
              </li>
              <li>
                <h2>{}</h2>
                <p>
                  Your picks can be changed{" "}
                  <strong>via a link in your confirmation email. </strong> If
                  you go to the main link again, it will be counted as a
                  separate entry (and another entry fee).
                </p>
              </li>
              <li>
                <h2>{}</h2>
                <p>
                  Your scores will be determined by your best 5 of those 6
                  players. Extra holes do not affect final scores.
                </p>
              </li>
              <li>
                <h2>{}</h2>
                <p>
                  Payouts are: 50 / 25 / 15 / 7 / 3% of the pot for 1st through
                  5th places.
                </p>
              </li>
              <li>
                <h2>{}</h2>
                <p>The 6th man will count as the first tiebreaker.</p>
              </li>
              <li>
                <h2>{}</h2>
                <p>
                  If a second tie breaker is necessary, your response for the
                  Total Number of Strokes question will be used. Lowest absolute
                  value of the difference (NOT Price-is-Right rules).
                </p>
              </li>
              <li>
                <h2>{}</h2>
                <p>
                  If any of your players miss the cut, they will be assigned the
                  highest score for the day +1. So, if your man misses the cut
                  or withdraws with back spasms and someone goes Tin Cup and
                  posts a Sunday 82, your man will be given an artificial 83 for
                  scoring purposes.
                </p>
              </li>
              <li>
                <h2>{}</h2>
                <p>
                  Use the "Group/Team/Company" question to be able to quickly
                  see how you are doing vs. your group of friends
                  <strong>
                    (who will presumably enter the same response).
                  </strong>
                </p>
              </li>
            </ol>
          </RulesDescription>
        </RulesContent>
      </RulesContainer>
    </Container>
  );
}
